import { Badge } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

type Props = {
  selectedTransfersCount: number;
};

export const TransferListHeader = ({ selectedTransfersCount }: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="flex gap-8">
      <span className="TransferListHeader__header__content">
        {t('invoices.transfer.paymentsSelected', {
          count: selectedTransfersCount,
        })}
      </span>
      <Badge variant="primary">{selectedTransfersCount}</Badge>
    </div>
  );
};
